import React from "react";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import AgencyFilter from "pages/Payments/AgencyFilter";
// import PositionTypeFilter from "./PositionTypeFilter";
// import Flatpickr from "react-flatpickr";
import OffCanvasFilter from "./OffCanvasFilter";
import MDAFilter from "pages/Payments/MDAFilter";
import RegionFilter from "pages/Payments/RegionFilter";

const Filters = ({
  setSearchValue,
  setPage,
  searchValue,
  setFilterValue,
  filterValue,
  defaultFilterValue,
  setSorted,
}: any) => {
  const [advancedFilter, setAdvancedFilter] = React.useState(false);

  const clearFilters = () => {
    setFilterValue(defaultFilterValue);
    setSearchValue("");
    setPage(1);
    setSorted([{ id: "createdAt", desc: true }]);
  };

  return (
    <Card>
      <CardBody>
        <Row className="g-3 ">
          <Col xxl={4} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Search</h6> */}
            <div className="search-box">
              <input
                type="text"
                className="form-control"
                placeholder="Search payments..."
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(1);
                }}
                value={searchValue}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Position type</h6> */}
            <RegionFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, region: value });
                setPage(1);
              }}
              value={filterValue.region}
            />
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Date Range</h6> */}
            {/* @ts-ignore */}
            <MDAFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, mda: value });
                setPage(1);
              }}
              value={filterValue.mda}
              regionId={filterValue.region?.value || ""}
            />
          </Col>
          <Col xxl={2} lg={6}>
            {/* <h6 className="text-uppercase fs-12 mb-2">Agency</h6> */}
            <AgencyFilter
              onChange={(value: any) => {
                setFilterValue({ ...filterValue, agency: value });
                setPage(1);
              }}
              value={filterValue.agency}
            />
          </Col>
          <Col xxl={2} lg={4}>
            {/* <h6 className="text-uppercase fs-12 mb-xxl-4"> {` `}</h6> */}

            <div className="w-100 d-flex gap-2">
              <button
                className="flex-grow-1 btn btn-light"
                onClick={() => {
                  clearFilters();
                }}
              >
                <i className="ri-restart-line align-bottom me-1"></i>
                Reset{" "}
              </button>

              <Button
                color="primary"
                className="flex-grow-1"
                onClick={() => {
                  setAdvancedFilter(true);
                }}
              >
                <i className="ri-equalizer-line align-bottom me-1"></i>
                Filters
              </Button>
            </div>

            {/* <ButtonGroup className="material-shadow w-100">
              <Button
                color="primary"
                className=""
                outline
                onClick={() => {
                  setFilterValue(defaultFilterValue);
                  setSearchValue("");
                  setPage(1);
                  setSorted([{ id: "createdAt", desc: true }]);
                }}
              >
                <i className="ri-restart-line align-bottom me-1"></i>
                Reset{" "}
              </Button>

              <Button color="primary" className="" onClick={() => {}}>
                <i className="ri-equalizer-line align-bottom me-1"></i>
                Filters
              </Button>
            </ButtonGroup> */}
          </Col>
        </Row>
      </CardBody>
      <OffCanvasFilter
        show={advancedFilter}
        onCloseClick={() => setAdvancedFilter(false)}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        setPage={setPage}
        clearFilters={clearFilters}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
      />
    </Card>
  );
};

export default Filters;
